import { Box, Group } from '@mantine/core'
import { Outlet } from 'react-router'
import { useLingui } from '@lingui/react/macro'
import { IconSpeakerphone, IconBolt } from '@tabler/icons-react'
import { createTestIdScope } from '@m3-tech/boss-utils'
import { useHasFeature } from '@m3-tech/boss-core'
import { FEATURE_COMMUNICATION_CAMPAIGN } from '@m3-tech/boss-types'
import { SidebarNav, type SidebarNavItem } from '@m3-tech/boss-ui'
import { TEST_ID_BASE, TestIdPage, TestIdSection } from '@/constants/testIds'

export function CommunicationSidebarLayout() {
    const { t } = useLingui()
    const tid = createTestIdScope(`${TEST_ID_BASE}-${TestIdPage.NAV}`)
    const hasCampaigns = useHasFeature(FEATURE_COMMUNICATION_CAMPAIGN)

    const items: SidebarNavItem[] = [
        ...(hasCampaigns
            ? [
                  {
                      id: 'campaigns',
                      path: '/campaigns',
                      label: t`Campaigns`,
                      icon: IconSpeakerphone,
                      testId: tid(TestIdSection.SIDEBAR, 'campaigns'),
                  },
              ]
            : []),
        {
            id: 'triggered',
            path: '/triggered',
            label: t`Triggered Communications`,
            icon: IconBolt,
            activePaths: ['/communication'],
            testId: tid(TestIdSection.SIDEBAR, 'triggered'),
        },
    ]

    const showSidebar = items.length > 1

    return (
        <Group wrap="nowrap" gap={0} h="100%" pl="md">
            {showSidebar && (
                <Box style={{ alignSelf: 'flex-start' }} mr="md" pt="md">
                    <SidebarNav items={items} testId={tid(TestIdSection.SIDEBAR)} />
                </Box>
            )}
            <Box flex={1} h="100%" px="md" py="md" style={{ minWidth: 0, overflowY: 'auto' }}>
                <Outlet />
            </Box>
        </Group>
    )
}
